export default (topicsQs) => {

    if (topicsQs) {
        toggleContainer('voyage-filtered-list', 'block');
        toggleContainer('hide-toggle', 'none');
        var title = document.getElementsByTagName('h1');
        var topicsTitle = document.querySelectorAll('[data-topicname="' + topicsQs + '"]');
        if (title && title.length > 0 && topicsTitle && topicsTitle.length > 0) {
            var filterTitle = document.getElementById('topicsFilterTitle');
            if (filterTitle) {
                filterTitle.innerText = " - " + topicsTitle[0].innerText;
            }
            else {
                var span = document.createElement('span');
                span.id = 'topicsFilterTitle';
                span.innerText = " - " + topicsTitle[0].innerText;
                title[0].append(span);
            }

            var titleSection = title[0].getElementsByTagName('span');
            if (titleSection && titleSection.length > 0) {
                titleSection[0].classList.add('do-not-show');
            }
        }

        var filterContainer = document.getElementById('Multi-field-Media');
        if (filterContainer) {
            var closeFilterTitle = document.getElementById('closeFilterTitle');
            if (!closeFilterTitle) {
                var div = document.createElement('div');
                div.classList.add('clear-filter');
                div.insertAdjacentHTML('beforeend', '<div class="voyage__section-title--link"><a id="closeFilterTitle" class="voyage__more-link"><div class="voyage__more-link--text">Back to all</div><div class="voyage__more-link--link">→</div></a></div>');
                filterContainer.parentNode.append(div);
            }
        }

        var closeFilter = document.getElementById('closeFilterTitle');
        if (closeFilter) {
            closeFilter.addEventListener('click', (e) => {
                e.preventDefault();
                location.href = location.href.split("?")[0];
            });
        }
    }
    else {
        toggleContainer('voyage-filtered-list', 'none');
        toggleContainer('hide-toggle', 'block');
        var title = document.getElementById('topicsFilterTitle');
        if (title) {
            title.remove();
        }
    }
}

export const voyageInsights2FilterTitle = (topicsQs) => {


    if (topicsQs) {
        toggleContainer('voyage-filtered-list', 'block');
        toggleContainer('hide-toggle', 'none');

        var filterContainer = document.getElementById('Multi-field-Media');
        if (filterContainer &&  topicsQs['topics']) {
            var topicsObject = topicsQs['topics'];
            var topicsValue = Array.isArray(topicsObject) ? topicsObject[0] : topicsObject;
            filterContainer.innerHTML = '';
            var div = document.createElement('div');
            var closeFilterTitle = document.getElementById('closeFilterTitle');
            var closeFilterHtml = !closeFilterTitle ? '<div class="voyage__section-title--link">' +
                                                        '<a id="closeFilterTitle" class="voyage__more-link">' +
                                                            '<div class="voyage__more-link--text">Back to all</div>' +
                                                            '<div class="voyage__more-link--link">→</div>' +
                                                        '</a>'
                                                    : '';
            div.insertAdjacentHTML('beforeend', '<div class="voyage__section-title">' +
                                                    '<div class="voyage__section-title--title">' + ((topics || {})[topicsValue] || '') + '</div>' +
                                                    closeFilterHtml +
                                                    '</div>' +
                                                '</div>');
            filterContainer.append(div);    
        }
        else if (filterContainer &&  topicsQs['themes']) {
            
            filterContainer.innerHTML = '';
            var div = document.createElement('div');
            var closeFilterTitle = document.getElementById('closeFilterTitle');
            var closeFilterHtml = !closeFilterTitle ? '<div class="voyage__section-title--link">' +
                                                        '<a id="closeFilterTitle" class="voyage__more-link">' +
                                                            '<div class="voyage__more-link--text">Back to all</div>' +
                                                            '<div class="voyage__more-link--link">→</div>' +
                                                        '</a>'
                                                    : '';
            div.insertAdjacentHTML('beforeend', '<div class="voyage__section-title">' +
                                                    '<div class="voyage__section-title--title">' + getThemeTitle(topicsQs['themes']) + '</div>' +
                                                    closeFilterHtml +
                                                    '</div>' +
                                                '</div>');
            filterContainer.append(div);    
        }

        var searchFilter = document.getElementById('filter-search-field');
        var filterList = document.getElementsByClassName('checkBoxGroup');
        if (searchFilter && filterList.length) {
            var isFilterListContainingSearchFilter = filterList[0].getElementsByClassName('filter-search-field-wrapper');
            if (!isFilterListContainingSearchFilter.length) {
                filterList[0].append(searchFilter.parentElement.parentElement);
            } 
        }

        var closeFilterTitle = document.getElementById('closeFilterTitle');
        if (!closeFilterTitle) {
            var filterContainer = document.getElementsByClassName('checkBoxGroup');
            if (filterContainer.length) {
                var div = document.createElement('div');
                div.classList.add('clear-filter');
                div.insertAdjacentHTML('beforeend', '<div class="voyage__section-title--link"><a id="closeFilterTitle" class="voyage__more-link"><div class="voyage__more-link--text">Back to all</div><div class="voyage__more-link--link">→</div></a></div>');
                filterContainer[0].append(div);
            }
        }  

        var closeFilter = document.getElementById('closeFilterTitle');
        if (closeFilter) {
            closeFilter.addEventListener('click', (e) => {
                e.preventDefault();
                location.href = location.href.split("?")[0];
            });
        }
    }
    else {
        toggleContainer('voyage-filtered-list', 'none');
        toggleContainer('hide-toggle', 'block');
        var title = document.getElementById('topicsFilterTitle');
        if (title) {
            title.remove();
        }
    }
}

function getThemeTitle(value) {
    var themesTitlesElement = document.querySelector("a.voyage__more-link[href*='?themes='");
    var themesTitle = themesTitlesElement && themesTitlesElement.parentElement && themesTitlesElement.parentElement.parentElement 
    ? themesTitlesElement.parentElement.parentElement.querySelector('div').innerText 
    : (document.getElementById(value) ? document.getElementById(value).innerText : '')
    return themesTitle;
}


const toggleContainer = (className, value) => {
    var toggleContainer = document.getElementsByClassName(className);
    if(toggleContainer.length) {
        Array.from(toggleContainer, function(container) {
            container.style.display = value;
        });
    }
}
